import toast, { Toast } from "react-hot-toast";
import {
  HiCheck,
  HiDownload,
  HiLightBulb,
  HiOutlineExclamationCircle,
  HiOutlineX,
} from "react-icons/hi";
import { translate } from "ui/i18n";

export function AlertSnackbar({
  type,
  title,
  text,
  t,
  onClose,
  onNoLongerDisplayed,
  variant = "primary",
}: {
  title: string;
  text?: string;
  type: "success" | "error" | "suggestion" | "download";
  t: Toast;
  onClose?: () => void;
  onNoLongerDisplayed?: () => void;
  variant?: "primary" | "secondary";
}) {
  const removeToast = () => {
    if (onClose) onClose();
    toast.remove(t.id);
  };

  return (
    <div
      className={`${t.visible ? "animate-enter" : "animate-leave"} ${
        variant === "primary" ? "bg-white" : "bg-darkGrey-800"
      } flex w-fit max-w-sm rounded-2xl shadow-lg`}
    >
      <div className="flex flex-1 items-start p-4">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-darkGrey-100">
          {type === "success" && (
            <HiCheck
              size={24}
              className={`${
                variant === "primary"
                  ? "text-secondaryGrey-900"
                  : "text-darkGrey-800"
              }`}
            />
          )}
          {type === "error" && (
            <HiOutlineExclamationCircle
              size={24}
              className={`${
                variant === "primary"
                  ? "text-secondaryGrey-900"
                  : "text-darkGrey-800"
              }`}
            />
          )}
          {type === "suggestion" && (
            <HiLightBulb
              size={24}
              className={`${
                variant === "primary"
                  ? "text-secondaryGrey-900"
                  : "text-darkGrey-800"
              }`}
            />
          )}
          {type === "download" && (
            <HiDownload
              size={24}
              className={`${
                variant === "primary"
                  ? "text-secondaryGrey-900"
                  : "text-darkGrey-800"
              }`}
            />
          )}
        </div>
        <div
          className={`ml-3 flex-1 ${text ? "" : "flex h-full items-center"}`}
        >
          <p
            className={`text-base font-bold ${
              variant === "primary" ? "text-secondaryGrey-900" : "text-white"
            }`}
          >
            {title}
          </p>
          {text && (
            <p
              className={`mt-1 text-sm font-medium ${
                variant === "primary" ? "text-secondaryGrey-700" : "text-white"
              }`}
            >
              {text}
            </p>
          )}
          {onNoLongerDisplayed && (
            <button
              className={`mt-4 w-fit text-sm font-bold underline ${
                variant === "primary" ? "text-secondaryGrey-900" : "text-white"
              }`}
              onClick={onNoLongerDisplayed}
            >
              {translate("ns1:Button.NoLongerDisplayed")}
            </button>
          )}
        </div>
      </div>
      <div className="p-3">
        <button onClick={removeToast} className="">
          <HiOutlineX
            size={20}
            className={`${
              variant === "primary" ? "text-secondaryGrey-900" : "text-white"
            }`}
          />
        </button>
      </div>
    </div>
  );
}
